import { reactive } from 'vue';

// A tiny reactive singleton so code outside any component instance (e.g. the
// router's navigation guard, which has no `this`/template) can still trigger
// the app's themed modal instead of a native window.alert(). A single
// <ConfirmModal> bound to `state` is mounted once in App.vue.
const state = reactive({
    visible: false,
    title: '',
    message: '',
});

export default {
    state,
    alert(message, title = 'Notice') {
        state.title = title;
        state.message = message;
        state.visible = true;
    },
};
